import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import bgImage from "../assets/hrlogo2.jpg";
import hrlogo from "../assets/hrsight-logo.png";
import { useAuthUser } from "../hooks/useAuth";
import { useGlobal } from "../contexts/GlobalContext";

const Login = () => {
  const [showModal, setShowModal] = useState(false);
  const [showError, setShowError] = useState(false);
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("john.doe2@example.com");
  const [password, setPassword] = useState("P@ssw0rd123");
  const navigate = useNavigate();

  const login = useAuthUser();
  const { setIsAuthenticated, setTriggerUserFetch } = useGlobal();

  useEffect(() => {
    if (login.isSuccess) {
      navigate("/EmployeeIndex");
    }
  }, [login.isSuccess, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    login.mutate(
      { email: username, password: password },
      {
        onSuccess: () => {
          setTriggerUserFetch(true);
          setIsAuthenticated(true);
        },
        onError: () => {
          setIsAuthenticated(false);
        },
      }
    );
  };

  const handleResetPassword = (e) => {
    e.preventDefault();
    console.log("Reset password link sent to:", email);
    alert("If this email exists, a password reset link has been sent.");
    setShowModal(false);
  };

  return (
    <div className="login-page">
      {/* Left side */}
      <div
        className="login-left"
        style={{ backgroundImage: `url(${bgImage})` }}
      >
        <div className="overlay">
          <h1>BUILDING THE FUTURE</h1>
          <p>Empowering your HR team with modern solutions</p>
        </div>
      </div>

      <div className="login-right">
        <div className="login-box">
          <img src={hrlogo} alt="HRIS Logo" className="login-logo" />
          <h2>Hello Team!</h2>
          <p>
            Welcome to <span className="brand">HRIS Portal</span>
          </p>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-footer">
              <button
                type="button"
                className="forgot-btn"
                onClick={() => setShowModal(true)}
              >
                Forgot password?
              </button>
            </div>

            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3>Reset Password</h3>
            <p>Enter your registered email to reset your password.</p>
            <form onSubmit={handleResetPassword}>
              <input
                type="email"
                placeholder="yourname@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <div className="modal-buttons">
                <button type="submit" className="modal-submit">
                  Send Link
                </button>
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="modal-cancel"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showError && (
        <div className="modal-overlay">
          <div className="modal-content error-modal">
            <h3>Invalid Login</h3>
            <p>Incorrect username or password. Please try again.</p>
            <div className="modal-buttons">
              <button
                type="button"
                className="modal-cancel"
                onClick={() => setShowError(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
